import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const Login = {
  login: (data: { username: string; password: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}auth/login`, data);
  },
  recoverPassword: (data: { username: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}auth/recovery-password`, data);
  },
  verifyPasswordRequest: (data: { user: string; uuid: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}auth/verify-password-request`, data);
  },
  changePassword: (data: { user: string; uuid: string; password: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}auth/change-password`, data);
  },
  verifyAccounts: (id: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/${id}/accounts`);
  }
};
